import { BaseModuleSharedApi } from "@/findifyv2-api-ts/base/BaseModuleSharedApi";

export class CountriesApi extends BaseModuleSharedApi {
  basePath = 'countries';
};